function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import clsx from 'clsx';
import { isEmptyOrNull, isNotEmptyOrNull } from '@tecsinapse/es-utils/build';
import { makeStyles, useTheme } from '@material-ui/styles';
import { IconButton } from '@material-ui/core';
import { mdiArrowUp, mdiArrowUpDown } from '@mdi/js';
import Icon from '@mdi/react';
var headerStyles = makeStyles(function (theme) {
  return {
    selectionColumn: {
      maxWidth: '7%'
    },
    ascending: {
      paddingTop: 0,
      paddingRight: theme.spacing(1 / 5),
      paddingBottom: theme.spacing(1 / 3),
      paddingLeft: theme.spacing(1 / 5),
      marginLeft: 'auto',
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },
    descending: {
      paddingTop: theme.spacing(1 / 3),
      paddingRight: theme.spacing(1 / 5),
      paddingBottom: 0,
      paddingLeft: theme.spacing(1 / 5),
      transform: 'rotate(180deg)'
    }
  };
});
var sortStyles = makeStyles(function () {
  return {
    sortedHover: {
      transition: 'opacity 0.25s',
      opacity: function opacity(_ref) {
        var sortedActive = _ref.sortedActive;
        return !sortedActive ? 1 : 100;
      },
      '&:hover': {
        opacity: 100
      }
    }
  };
});

var getSelectedRowsPage = function getSelectedRowsPage(data, selectedRows, rowId) {
  return isEmptyOrNull(selectedRows) ? [] : selectedRows.filter(function (selected) {
    return data.some(function (rowData) {
      return rowId(rowData) === rowId(selected);
    });
  });
};

var selectAll = function selectAll(data, selectedRows, setSelectedRows, onSelectRow, rowId) {
  return function () {
    var selectedRowsPage = getSelectedRowsPage(data, selectedRows, rowId);
    var newSelectedRows = isEmptyOrNull(selectedRows) ? [] : selectedRows.filter(function (selected) {
      return data.every(function (rowData) {
        return rowId(rowData) !== rowId(selected);
      });
    });
    var checked = false;

    if (isEmptyOrNull(selectedRowsPage) || selectedRowsPage.length !== data.length) {
      newSelectedRows = newSelectedRows.concat(data);
      checked = true;
    }

    setSelectedRows(newSelectedRows);

    if (onSelectRow) {
      onSelectRow(newSelectedRows, null, checked);
    }
  };
};

var convertColumnToTableCell = function convertColumnToTableCell(_ref2, selectedRows, setSelectedRows, data, onSelectRow, classes, rowId, filters, onChangeSortFilter, theme, sortedColumIndex, setSortedColumIndex, index) {
  var field = _ref2.field,
      title = _ref2.title,
      _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? {} : _ref2$options,
      selection = _ref2.selection;
  var sortedActive = sortedColumIndex === index;
  var sortClasses = sortStyles({
    sortedActive: sortedActive
  });
  var _options$visible = options.visible,
      visible = _options$visible === void 0 ? true : _options$visible;
  var _options$sort = options.sort,
      sort = _options$sort === void 0 ? false : _options$sort;

  if (!visible) {
    return null;
  }

  if (selection) {
    var selectedRowsPage = getSelectedRowsPage(data, selectedRows, rowId);
    var indeterminate = isNotEmptyOrNull(selectedRowsPage) && selectedRowsPage.length !== data.length;
    var checked = isNotEmptyOrNull(selectedRowsPage) && selectedRowsPage.length === data.length;
    return /*#__PURE__*/React.createElement(TableCell, {
      key: field,
      padding: "checkbox",
      className: classes.selectionColumn
    }, /*#__PURE__*/React.createElement(Checkbox, {
      indeterminate: indeterminate,
      checked: checked,
      onClick: selectAll(data, selectedRows, setSelectedRows, onSelectRow, rowId)
    }));
  }

  return /*#__PURE__*/React.createElement(TableCell, {
    key: field,
    align: options.numeric ? 'right' : 'left'
  }, !options.numeric && title, sort && /*#__PURE__*/React.createElement(IconButton, {
    disableFocusRipple: true,
    disableRipple: true,
    onClick: function onClick() {
      setSortedColumIndex(index);
      return onChangeSortFilter(field);
    },
    className: clsx(classes.ascending, sortClasses.sortedHover, _defineProperty({}, classes.descending, !filters.ascending))
  }, /*#__PURE__*/React.createElement(Icon, {
    path: sortedActive ? mdiArrowUp : mdiArrowUpDown,
    color: field === filters.sortField && sortedActive ? theme.palette.text.primary : theme.palette.text.disabled,
    size: 0.8
  })), options.numeric && title);
};

var Header = function Header(_ref3) {
  var columns = _ref3.columns,
      selectedRows = _ref3.selectedRows,
      setSelectedRows = _ref3.setSelectedRows,
      data = _ref3.data,
      onSelectRow = _ref3.onSelectRow,
      rowId = _ref3.rowId,
      tableHeaderHide = _ref3.tableHeaderHide,
      filters = _ref3.filters,
      onChangeSortFilter = _ref3.onChangeSortFilter;
  var classes = headerStyles();
  var theme = useTheme();
  var effectRef = useRef(false);

  var _useState = useState(columns.findIndex(function (item) {
    var _item$options;

    return !!((_item$options = item.options) === null || _item$options === void 0 ? void 0 : _item$options.defaultSort);
  })),
      _useState2 = _slicedToArray(_useState, 2),
      sortedColumIndex = _useState2[0],
      setSortedColumIndex = _useState2[1];

  useEffect(function () {
    if (!effectRef.current && sortedColumIndex !== -1) {
      var _columns$sortedColumI;

      onChangeSortFilter(columns[sortedColumIndex].field, (_columns$sortedColumI = columns[sortedColumIndex].options) === null || _columns$sortedColumI === void 0 ? void 0 : _columns$sortedColumI.defaultSort);
    }
  }, [effectRef]); // eslint-disable-line react-hooks/exhaustive-deps

  if (tableHeaderHide) {
    return null;
  }

  var tableCells = null;

  if (columns && columns.length > 0) {
    tableCells = columns.map(function (column, index) {
      return convertColumnToTableCell(column, selectedRows, setSelectedRows, data, onSelectRow, classes, rowId, filters, onChangeSortFilter, theme, sortedColumIndex, setSortedColumIndex, index);
    });
  }

  return /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, tableCells));
};

Header.defaultProps = {
  selectedRows: null,
  onSelectRow: null,
  setSelectedRows: null,
  tableHeaderHide: false
};
Header.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedRows: PropTypes.arrayOf(PropTypes.object),
  onSelectRow: PropTypes.func,
  setSelectedRows: PropTypes.func,
  tableHeaderHide: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  rowId: PropTypes.func.isRequired
};
export default Header;